import {useMemo} from 'react';
import {useQuery} from 'react-query';
import {FormService} from 'crqlar-react-common/dist/services/forms/form.service';
import {SurveyService} from 'crqlar-react-common/dist/services/survey/survey.service';
import {AutomationSurveyOption} from '../components/v2/types';

/** The forms and surveys the node dialogs offer (form and survey triggers, Send Survey). */
export const useNodeDialogCatalogues = () => {
    const {data: formsResponse, isLoading: formsLoading} = useQuery({
        queryKey: ['forms-list', 'all'],
        queryFn: async () => {
            const response = await FormService.listForms({
                limit: {
                    offset: 0,
                    limit: 1000
                }
            });
            return response.content || [];
        }
    });

    // Drafts too: a survey trigger is often wired up before the survey goes live.
    const {data: surveysResponse, isLoading: surveysLoading} = useQuery({
        queryKey: ['surveys-list', 'all'],
        queryFn: async () => {
            const response = await SurveyService.getAllSurveys({
                limit: {
                    offset: 0,
                    limit: 1000,
                    sort: [{field: 'name', direction: 'ASC'}]
                }
            });
            return response.content || [];
        }
    });

    const availableSurveys: AutomationSurveyOption[] = useMemo(
        () => (surveysResponse || [])
            .filter(survey => !!survey.id)
            .map(survey => ({
                id: survey.id!,
                name: survey.name,
                type: survey.type,
                status: survey.status
            })),
        [surveysResponse]
    );

    return {
        availableForms: formsResponse || [],
        formsLoading,
        availableSurveys,
        surveysLoading
    };
};
